export default __webpack_public_path__ + "static/product1-d64c808da99b6545557a99d3e98c6b27.png";